/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
import { IoSearchOutline } from "react-icons/io5";
// import EdvironLogo from "../../../../assets/EdvironLogo.svg";
import { useQuery } from "@apollo/client";
import {
  Table,
  Pagination,
  RowsPerPageSelect,
} from "../../../components/Table";
import { GET_TRANSACTION_REPORT } from "../../../Qurries";
import { dashboardContext } from "../Dashboard";
import { Link, useLocation } from "react-router-dom";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { HiMiniXMark } from "react-icons/hi2";
import { CustomDropdownIndicator } from "../Settlement/Settlement";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { HiOutlineExternalLink } from "react-icons/hi";
import TransactionDateFilter, {
  formatDate,
} from "./components/TransactionDateFilter";
import MixFilter from "./components/MixFilter";
import Select from "react-select";
import { getPaymentMode } from "../../../utils/getPaymentMode";
import { endOfDay, startOfDay } from "date-fns";
import axios from "axios";
import { getNormalizeObjectsArray } from "../../../utils/getnormalizeObjectsArray";
import { usePaymentUrlFilters } from "../../../hooks/usePaymentUrlFilters";
import {
  buildCheckboxState,
  getActiveCheckboxKeys,
  parseCommaList,
  parseDateParam,
  serializeCommaList,
} from "../../../utils/paymentUrlFilters";
export const handleCheckboxChange = (
  category: any,
  option: any,
  setFilters: any,
) => {
  setFilters((prevFilters: any) => ({
    ...prevFilters,
    [category]: {
      ...prevFilters[category],
      [option]: !prevFilters[category][option],
    },
  }));
};
export const payment_method_map: any = {
  credit_card: "Credit Card",
  debit_card: "Debit Card",
  net_banking: "Net Banking",
  UPI: "UPI",
  upi: "UPI",
  upi_ppi: "UPI",
  wallet: "Wallet",
  credit_card_emi: "Credit Card EMI",
  debit_card_emi: "Debit Card EMI",
  cardless_emi: "Cardless EMI",
  pay_later: "Pay Later",
  upi_credit_card: "UPI Credit Card",
  vba: "Bank Transfer(VBA)",
  pos_credit_card: "POS Credit Card",
  pos_debit_card: "POS Debit Card",
  pos_qr: "POS QR",
  cash: "Cash",
  cheque: "Cheque",
  demand_draft: "Demand Draft",
};
export const gatewayName = {
  PHONEPE: "PHONEPE",
  HDFC: "HDFC",
  EDVIRON_PG: "CASHFREE",
  EDVIRON_PAY_U: "PAY U",
  EDVIRON_CCAVENUE: "CCAVENUE",
  EDVIRON_EASEBUZZ: "EASEBUZZ",
  PENDING: "PENDING",
  EXPIRED: "EXPIRED",
  EDVIRON_HDFC_RAZORPAY: "HDFC RAZORPAY",
  SMART_GATEWAY: "SMART GATEWAY",
  PAYTM_POS: "PAYTM POS",
  MOSAMBEE_POS: "MOSAMBEE POS",
  EDVIRON_NTTDATA: "NTT DATA",
  EDVIRON_WORLDLINE: "WORLDLINE",
  EDVIRON_RAZORPAY: "RAZORPAY",
  EDVIRON_RAZORPAY_SEAMLESS: "RAZORPAY SEAMLESS",
  EDVIRON_GATEPAY: "GATEPAY",
  EDVIRON_PAY: "EDVIRON PAY",
};
function Transaction() {
  const { get, getNumber, getBoolean, updateParams, searchParams } =
    usePaymentUrlFilters();
  const location = useLocation();
  const returnPath = `${location.pathname}${location.search}`;
  console.log(returnPath);
  const skipUrlSyncRef = useRef(true);

  const [transactionData, setTransactionData] = useState<any>([]);
  const [searchText, setSearchText] = useState<string>(() => get("search"));
  const { user } = useContext(dashboardContext);
  const [, setTransactionAmount] = useState(0);
  const [, setOrderAmountTotal] = useState(0);

  const [transactionReportData, settransactionReportData] = useState<any>([]);
  const todayRange = {
    startDate: startOfDay(new Date()),
    endDate: endOfDay(new Date()),
  };

  const urlStartDate = parseDateParam(get("start_date"));
  const urlEndDate = parseDateParam(get("end_date"));
  const urlDateRange = get("date_range", "Today");

  const startDate = formatDate(todayRange.startDate);
  const endDate = formatDate(todayRange.endDate);

  const [status, setStatus] = useState<any>(() => get("status") || null);
  const [isCustomSearch, setIsCustomSearch] = useState(false);
  const [searchFilter, setSearchFilter] = useState<any>(() =>
    get("search_filter"),
  );
  const [currentPage, setCurrentPage] = useState(() => getNumber("page", 1));
  const [isDateRangeIsSelected, setIsDateRangeIsSelected] = useState(() =>
    getBoolean("custom_date"),
  );
  const [dateRange, setDateRange] = useState(urlDateRange);
  const [selectedRange, setSelectedRange] = useState({
    startDate: urlStartDate || todayRange.startDate,
    endDate: urlEndDate || todayRange.endDate,
    key: "selection",
  });
  const getActiveDateRange = () => {
    if (isDateRangeIsSelected) {
      return {
        start: formatDate(selectedRange.startDate),
        end: formatDate(selectedRange.endDate),
      };
    }

    return {
      start: formatDate(todayRange.startDate),
      end: formatDate(todayRange.endDate),
    };
  };

  const [refetchLoading, setRefetchLoading] = useState(false);
  const [selectSchool, setSelectSchool] = useState<any>(() => get("school_name"));
  const [schoolId, setSchoolId] = useState<any>(() => get("school_id") || null);
  const [itemsPerRow, setItemsPerRow] = useState({
    name: getNumber("limit", 10),
  });
  const [type, setType] = useState(() => get("filter_type"));
  const [totalPages, setTotalPages] = useState(0);
  const [transactionAmountDetails, setTransactionAmountDetails] =
    useState<any>(null);

  const defaultPaymentModeKeys = [
    "credit_card",
    "credit_card_emi",
    "upi",
    "wallet",
    "pay_later",
    "cardless_emi",
    "net_banking",
    "debit_card_emi",
    "debit_card",
    "na",
    "qr",
    "vba",
    "pos_credit_card",
    "pos_debit_card",
    "pos_qr",
    "cash"
  ];

  const [filters, setFilters] = useState<any>(() => ({
    paymentMode: buildCheckboxState(
      defaultPaymentModeKeys,
      parseCommaList(get("payment_modes")),
    ),
    gateway: buildCheckboxState(
      Object.keys(gatewayName),
      parseCommaList(get("gateway")),
    ),
    vendor_id: get("vendor_id") || null,
  }));
  const [additionalData, setAdditionalData] = useState<any>([
    { column: [""], values: [] },
  ]);

  const { loading: transactionReportLoading, refetch } = useQuery(
    GET_TRANSACTION_REPORT,
    {
      onCompleted: (data) => {
        const formattedData =
          data.getMerchantTransactionReport.transactionReport.map(
            (row: any, index: number) => {
              const gatewayKey =
                row.gateway?.toUpperCase() as keyof typeof gatewayName;
              const gatewayname =
                gatewayKey && gatewayName[gatewayKey]
                  ? gatewayName[gatewayKey]
                  : "NA";

              return {
                transactionTime: row.payment_time || row.updatedAt || row.createdAt,
                orderID: row.collect_id,
                details: row.details,
                transactionAmount:
                  row.transaction_amount === null
                    ? "--"
                    : row.transaction_amount,
                paymentMode:
                  row.payment_method === "" || row.payment_method === null
                    ? "NA"
                    : payment_method_map[row.payment_method],
                orderAmount:
                  row.order_amount === null ? "--" : row.order_amount,
                transactionStatus:
                  row.status === null ? "NA" : row.status.toLowerCase(),
                ...row,
                serialNumber: (currentPage - 1) * itemsPerRow.name + 1 + index,
                gateway: gatewayname,
                student_id: row.student_id,
              };
            },
          );
        setAdditionalData(
          getNormalizeObjectsArray(
            data.getMerchantTransactionReport?.transactionReport?.map(
              (d: any) => {
                console.log(d);

                if (!d?.additional_data || d?.additional_data === "null") {
                  return {};
                } else {
                  return JSON.parse(d.additional_data);
                }
              },
            ),
          ),
        );

        setTransactionData(formattedData);
        settransactionReportData(formattedData);
        setTotalPages(data.getMerchantTransactionReport?.total_pages || 0);
      },
      variables: {
        startDate: startDate,
        endDate: endDate,
        page: currentPage.toString(),
        limit: itemsPerRow.name.toString(),
        //isQRCode: true,
      },
    },
  );

  const refetchDataFetch = useCallback(
    async ({
      start_date,
      end_date,
      page,
      status,
      school_id,
      isCustomSearch,
      searchFilter,
      searchParams,
      payment_modes,
      limit,
      isQrCode,
      gateway,
      vendor_id,
    }: {
      start_date?: any;
      end_date?: any;
      page?: String;
      status?: String;
      school_id?: String;
      isCustomSearch?: boolean;
      searchFilter?: String;
      searchParams?: String;
      limit?: String;
      payment_modes?: string[] | null;
      isQrCode?: boolean;
      gateway?: string[] | null;
      vendor_id?: String | null;
    }) => {
      setRefetchLoading(true);
      try {
        const res = await refetch({
          startDate: start_date,
          endDate: end_date,
          page: page,
          limit: limit,
          status,
          school_id,
          isCustomSearch: isCustomSearch,
          searchFilter,
          searchParams,
          payment_modes: isQrCode ? null : payment_modes,
          isQRCode: isQrCode,
          gateway,
          vendorId: vendor_id,
        });
        if (res) {
          setRefetchLoading(false);
          setTotalPages(
            res.data.getMerchantTransactionReport?.total_pages || 0,
          );
          setAdditionalData(
            getNormalizeObjectsArray(
              res.data.getMerchantTransactionReport?.transactionReport?.map(
                (d: any) => {
                  console.log(d);

                  if (!d?.additional_data || d?.additional_data === "null") {
                    return {};
                  } else {
                    return JSON.parse(d.additional_data);
                  }
                },
              ),
            ),
          );
          setTransactionData(
            res?.data.getMerchantTransactionReport.transactionReport.map(
              (row: any, index: number) => {
                const gatewayKey =
                  row.gateway?.toUpperCase() as keyof typeof gatewayName;
                const gatewayname =
                  gatewayKey && gatewayName[gatewayKey]
                    ? gatewayName[gatewayKey]
                    : "NA";

                const pageToUse =
                  page !== undefined ? Number(page) : currentPage;
                return {
                  transactionTime: row.payment_time || row.updatedAt || row.createdAt,
                  orderID: row.collect_id,
                  details: row.details,
                  transactionAmount:
                    row.transaction_amount === null
                      ? "--"
                      : row.transaction_amount,
                  paymentMode:
                    row.payment_method === "" || row.payment_method === null
                      ? "NA"
                      : payment_method_map[row.payment_method],
                  orderAmount:
                    row.order_amount === null ? "--" : row.order_amount,
                  transactionStatus:
                    row.status === null ? "NA" : row.status.toLowerCase(),
                  ...row,
                  serialNumber: (pageToUse - 1) * itemsPerRow.name + 1 + index,
                  gateway: gatewayname,
                  student_id: row.student_id,
                };
              },
            ),
          );
        }
      } catch (error) {
        if (error) {
          setRefetchLoading(false);
        }
      }
    },
    [currentPage, itemsPerRow, refetch, setRefetchLoading, setTransactionData],
  );
  const GET_TRANSACTION_AMOUNT = useCallback(
    (
      start_date: String,
      end_date: String,
      trustee_id: String,
      school_id: String,
      vendor_id: String,
      status: String,
      mode?: string[] | null,
      isQrCode?: boolean,
      gateway?: string[] | null,
    ) => {
      const token = localStorage.getItem("merchantToken");
      axios
        .post(
          `${process.env.REACT_APP_PAYMENT_BACKEND_URL}/edviron-pg/get-transaction-report-batched`,
          {
            trustee_id,
            school_id: school_id,
            start_date: start_date,
            end_date: end_date,
            status: status,
            mode: isQrCode ? null : mode,
            isQRPayment: isQrCode,
            vendor_id: vendor_id,
            gateway: gateway,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          setTransactionAmountDetails(response.data.transactions[0]);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    [],
  );

  useEffect(() => {
    const { start, end } = getActiveDateRange();
    GET_TRANSACTION_AMOUNT(
      start,
      end,
      user?.getMerchantQuery?.trustee_id,
      user?.getMerchantQuery?.school_id,
      filters.vendor_id,
      status ? status?.toUpperCase() : "SUCCESS",
      getPaymentMode(filters.paymentMode, type),
      getPaymentMode(filters.paymentMode, type)?.includes("qr"),
      getPaymentMode(filters.gateway, type)
    );
  }, [
    type,
    status,
    selectSchool,
    searchFilter,
    itemsPerRow,
    selectedRange.startDate,
    selectedRange.endDate,
    filters.paymentMode,
    filters.gateway,
    isDateRangeIsSelected,
    user?.getMerchantQuery?.school_id,
    user?.getMerchantQuery?.trustee_id,
    GET_TRANSACTION_AMOUNT,
    filters.vendor_id,
  ]);

  useEffect(() => {
    const amount: any = [];
    const order_amount: any = [];
    transactionData.forEach((d: any) => {
      if (d.transactionStatus === "success") {
        amount.push(d.transaction_amount);
        order_amount.push(d.order_amount);
      }
    });

    setOrderAmountTotal(
      order_amount?.reduce((a: any, current: any) => a + current, 0),
    );
    setTransactionAmount(
      amount?.reduce((a: any, current: any) => a + current, 0),
    );
  }, [transactionData]);

  // useEffect(() => {
  //   refetchDataFetch({
  //     start_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.startDate)
  //       : startDate,
  //     end_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.endDate)
  //       : endDate,
  //     page: currentPage.toString(),
  //     status: status?.toUpperCase(),
  //     limit: itemsPerRow.toString(),
  //     school_id: selectSchool === "" ? null : schoolId,
  //     payment_modes:
  //       Object.keys(filters.paymentMode).filter(
  //         (key) => filters.paymentMode[key]
  //       ).length > 0
  //         ? Object.keys(filters.paymentMode).filter(
  //             (key) => filters.paymentMode[key]
  //           )
  //         : null,
  //     isQrCode: getPaymentMode(filters.paymentMode, type)?.includes("qr"),
  //     gateway: getPaymentMode(filters.gateway, type),
  //   });

  // }, [
  //   currentPage,
  //   itemsPerRow,
  //   isDateRangeIsSelected,
  //   selectedRange.startDate,
  //   selectedRange.endDate,
  //   startDate,
  //   endDate,
  //   status,
  //   selectSchool,
  //   schoolId,
  //   filters.paymentMode,
  //   filters.gateway,
  //   type,
  //   refetchDataFetch,
  // ]);
  const handlePageChange = (page: any) => {
    setCurrentPage(page);
    const { start, end } = getActiveDateRange();
    refetchDataFetch({
      page: page.toString(),
      isCustomSearch: isCustomSearch,
      searchFilter: searchFilter,
      searchParams: searchText,
      start_date: start,
      end_date: end,
      status: status?.toUpperCase(),
      limit: itemsPerRow.name.toString(),
      school_id: selectSchool === "" ? null : schoolId,
      payment_modes: getPaymentMode(filters.paymentMode, type)?.includes("qr")
        ? null
        : getPaymentMode(filters.paymentMode, type),
      isQrCode: getPaymentMode(filters.paymentMode, type)?.includes("qr"),
      gateway: getPaymentMode(filters.gateway, type),
      vendor_id: filters.vendor_id,
    });
  };

  useEffect(() => {
    if (
      searchText.length > 1 &&
      ["order_id", "custom_order_id"].includes(searchFilter)
    ) {
      setIsCustomSearch(true);
    } else {
      setIsCustomSearch(false);
    }
  }, [searchText, searchFilter]);

  const getReceiptLink = (orderID: string, school_id: string) => ({
    pathname: `/payments/transaction-receipt/${orderID}`,
    search: `?sid=${school_id}`,
    state: { from: returnPath },
  });

  useEffect(() => {
    const fetchFromUrl = async () => {
      if (searchParams.toString().length > 0) {
        const { start, end } = getActiveDateRange();
        await refetchDataFetch({
          page: currentPage.toString(),
          isCustomSearch:
            searchText.length > 1 &&
            ["order_id", "custom_order_id"].includes(searchFilter),
          searchFilter: searchFilter,
          searchParams: searchText,
          start_date: start,
          end_date: end,
          status: status?.toUpperCase(),
          limit: itemsPerRow.name.toString(),
          school_id: selectSchool === "" ? null : schoolId,
          payment_modes: getPaymentMode(filters.paymentMode, type)?.includes(
            "qr",
          )
            ? null
            : getPaymentMode(filters.paymentMode, type),
          isQrCode: getPaymentMode(filters.paymentMode, type)?.includes("qr"),
          gateway: getPaymentMode(filters.gateway, type),
          vendor_id: filters.vendor_id,
        });
      }
      skipUrlSyncRef.current = false;
    };

    fetchFromUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (skipUrlSyncRef.current) return;

    const { start, end } = getActiveDateRange();
    const paymentModes = getActiveCheckboxKeys(filters.paymentMode);
    const gateways = getActiveCheckboxKeys(filters.gateway);

    updateParams({
      page: currentPage > 1 ? currentPage : null,
      limit: itemsPerRow.name !== 10 ? itemsPerRow.name : null,
      search: searchText || null,
      search_filter: searchFilter || null,
      status: status || null,
      start_date:
        isDateRangeIsSelected || dateRange !== "Today" ? start : null,
      end_date: isDateRangeIsSelected || dateRange !== "Today" ? end : null,
      date_range: dateRange !== "Today" ? dateRange : null,
      custom_date: isDateRangeIsSelected ? true : null,
      school_id: schoolId || null,
      school_name: selectSchool || null,
      payment_modes: serializeCommaList(paymentModes) || null,
      gateway: serializeCommaList(gateways) || null,
      vendor_id: filters.vendor_id || null,
      filter_type: type || null,
    });
  }, [
    currentPage,
    searchText,
    searchFilter,
    status,
    itemsPerRow.name,
    dateRange,
    isDateRangeIsSelected,
    selectedRange.startDate,
    selectedRange.endDate,
    selectSchool,
    schoolId,
    filters.paymentMode,
    filters.gateway,
    filters.vendor_id,
    type,
    updateParams,
  ]);

  return (
    <div className="overflow-hidden">
      <h2 className="text-[#1B163B] text-[28px] ml-4 font-[600]">
        Transactions
      </h2>
      <div className="w-full  grid xl:grid-cols-2 gap-4 mb-2">
        <div className="xl:col-span-1 col-span-2">
          <h2 className="text-[#1B163B] xl:text-[24px] text-lg ml-2  font-[400]">
            Transactions Amount
          </h2>

          <div className="text-[#229635] font-[400] flex items-center ">
            {/* {transactionReportLoading || refetchLoading ? (
              <img
                src={PriceLoading}
                className=" w-10 h-10 animate-spin"
                alt="loading"
              />
            ) : (
              <>
                
              </>
            )} */}

            <span className="xl:text-[44px] text-3xl flex items-center">
              <LiaRupeeSignSolid />{" "}
              {transactionAmountDetails &&
              (status === "success" || status === null) ? (
                <span>
                  {transactionAmountDetails?.totalTransactionAmount.toLocaleString(
                    "hi-in",
                  )}
                </span>
              ) : (
                <span>0</span>
              )}
            </span>
            <span className="text-[20px] text-[#717171] flex items-center ml-2">
              {` (selected period )`}
            </span>
          </div>
        </div>

        <div className="xl:col-span-1 col-span-2">
          <h2 className="text-[#1B163B] xl:text-[24px] text-lg ml-2  font-[400]">
            Order Amount
          </h2>
          <div className="text-[#229635] font-[400] flex items-center ">
            <span className="xl:text-[44px] text-3xl flex items-center">
              <LiaRupeeSignSolid />
              {transactionAmountDetails &&
              (status === "success" || status === null) ? (
                <span>
                  {transactionAmountDetails?.totalOrderAmount.toLocaleString(
                    "hi-in",
                  )}
                </span>
              ) : (
                <span>0</span>
              )}
            </span>
            <span className="text-[20px] text-[#717171] flex items-center ml-2">
              {` (selected period )`}
            </span>
          </div>
        </div>
      </div>
      {transactionReportData ? (
        <Table
          perPage={false}
          exportBtn={true}
          heading={"History"}
          pagination={false}
          copyContent={[3]}
          filter={[searchText]}
          loading={refetchLoading || transactionReportLoading}
          isCustomFilter={true}
          searchBox={
            <div className="w-full ">
              <div className="flex xl:!flex-row flex-col justify-between gap-2  w-full xl:items-center items-start mb-2">
                <div className="bg-[#EEF1F6] py-3 items-center flex  px-3 xl:max-w-md max-w-[34rem] w-full rounded-lg">
                  <input
                    className="text-xs pr-2 bg-transparent focus:outline-none w-full placeholder:font-normal"
                    type="text"
                    value={searchText}
                    placeholder=" Search(Order ID...)"
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                  {searchFilter !== "" && searchText.length > 1 && (
                    <HiMiniXMark
                      onClick={async () => {
                        setSearchFilter("");
                        setSearchText("");
                        setCurrentPage(1);
                        const { start, end } = getActiveDateRange();
                        refetchDataFetch({
                          page: "1",
                          start_date: start,
                          end_date: end,
                          status: status?.toUpperCase(),
                          limit: itemsPerRow.name.toString(),
                          school_id: selectSchool === "" ? null : schoolId,
                          payment_modes: getPaymentMode(
                            filters.paymentMode,
                            type,
                          ),
                          isQrCode: getPaymentMode(
                            filters.paymentMode,
                            type,
                          )?.includes("qr"),
                          gateway: getPaymentMode(filters.gateway, type),
                          vendor_id: filters.vendor_id,
                        });
                      }}
                      className="text-[#1E1B59] cursor-pointer text-md mr-2 shrink-0"
                    />
                  )}
                  <Select
                    className="border-l-2 border-gray-400"
                    options={[
                      {
                        label: "By Order ID",
                        value: "custom_order_id",
                      },
                      { label: "By Edviron Order ID", value: "order_id" },
                      { label: "By Student Info", value: "student_info" },
                      {
                        label: "By UPI Transaction ID",
                        value: "bank_reference",
                      },
                      { label: "By UPI Id", value: "upi_id" },
                    ]}
                    isSearchable={false}
                    components={{
                      DropdownIndicator: CustomDropdownIndicator,
                      IndicatorSeparator: () => null,
                    }}
                    onChange={(e: any) => {
                      setSearchFilter(e.value.toLowerCase());
                      setCurrentPage(1);
                    }}
                    placeholder={
                      <div className="text-[#1E1B59] -mt-1 capitalize text-[10px]">
                        {searchFilter === ""
                          ? "filter by"
                          : searchFilter
                                .toString()
                                .toLowerCase()
                                .replaceAll("_", " ") === "order id"
                            ? "Edviron Order ID"
                            : searchFilter
                                .toString()
                                .toLowerCase()
                                .replaceAll("_", " ")}
                      </div>
                    }
                    value={searchFilter}
                    styles={{
                      control: (provided: any) => ({
                        ...provided,
                        backgroundColor: "transparent",
                        height: "20px",
                        border: "none",
                        boxShadow: "none",
                        cursor: "pointer",
                        minHeight: "10px",
                        padding: "0px",
                      }),
                      valueContainer: (provided: any) => ({
                        ...provided,
                        height: "20px",
                        width: "8rem",
                        padding: "0 8px",
                      }),
                      input: (provided: any) => ({
                        ...provided,
                        margin: "0",
                        padding: "0",
                      }),
                      placeholder: (provided: any) => ({
                        ...provided,
                        margin: "0",
                        padding: "0",
                        lineHeight: "20px",
                      }),
                      singleValue: (provided: any) => ({
                        ...provided,
                        lineHeight: "20px",
                      }),
                      indicatorsContainer: (provided: any) => ({
                        ...provided,
                        height: "20px",
                      }),
                      option: (provided: any) => ({
                        ...provided,
                        fontSize: "10px",
                        cursor: "pointer",
                      }),
                    }}
                  />

                  <div className="w-10 z-50 shrink-0 flex justify-center items-center">
                    {searchText.length > 1 && refetchLoading ? (
                      <AiOutlineLoading3Quarters className="text-xs animate-spin" />
                    ) : (
                      <IoSearchOutline
                        onClick={() => {
                          if (searchText.length > 1 && searchFilter !== "") {
                            setCurrentPage(1);
                            const { start, end } = getActiveDateRange();
                            refetchDataFetch({
                              isCustomSearch,
                              page: "1",
                              limit: itemsPerRow.name.toString(),
                              searchFilter: searchFilter,
                              searchParams: searchText,
                              start_date: start,
                              end_date: end,
                              status: status?.toUpperCase(),
                              school_id: schoolId === "" ? null : schoolId,
                              payment_modes: getPaymentMode(
                                filters.paymentMode,
                                type,
                              ),
                              isQrCode: getPaymentMode(
                                filters.paymentMode,
                                type,
                              )?.includes("qr"),
                              gateway: getPaymentMode(filters.gateway, type),
                              vendor_id: filters.vendor_id,
                            });
                          }
                        }}
                        className=" cursor-pointer text-edvion_black text-opacity-50 text-md "
                      />
                    )}
                  </div>
                </div>

                <div className="flex justify-end items-center flex-1 w-full max-w-[34rem]">
                  <TransactionDateFilter
                    setType={setDateRange}
                    type={dateRange}
                    refetch={() => {
                      setCurrentPage(1);
                      const { start, end } = getActiveDateRange();
                      refetchDataFetch({
                        page: "1",
                        limit: itemsPerRow.name.toString(),
                        isCustomSearch: isCustomSearch,
                        searchFilter: searchFilter,
                        searchParams: searchText,
                        start_date: start,
                        end_date: end,
                        status: status ? status?.toUpperCase() : null,
                        school_id: schoolId === "" ? null : schoolId,
                        payment_modes: getPaymentMode(
                          filters.paymentMode,
                          type,
                        ),
                        isQrCode: getPaymentMode(
                          filters.paymentMode,
                          type,
                        )?.includes("qr"),
                        gateway: getPaymentMode(filters.gateway, type),
                        vendor_id: filters.vendor_id,
                      });
                    }}
                    selectedRange={selectedRange}
                    setSelectedRange={setSelectedRange}
                    setIsDateRangeIsSelected={setIsDateRangeIsSelected}
                  />
                  <div className="w-full">
                    <Select
                      className="font-normal m-0 p-2 capitalize"
                      options={[
                        { label: "SUCCESS", value: "SUCCESS" },
                        { label: "PENDING", value: "PENDING" },
                        { label: "FAILED", value: "FAILED" },
                        { label: "USER DROPPED", value: "USER_DROPPED" },
                      ].map((status: any) => {
                        return {
                          label: status.label?.toLowerCase(),
                          value: status.value?.toLowerCase(),
                        };
                      })}
                      components={{
                        DropdownIndicator: CustomDropdownIndicator,
                        IndicatorSeparator: () => null,
                      }}
                      onChange={(e: any) => {
                        setStatus(e.value);
                        setCurrentPage(1);
                        const { start, end } = getActiveDateRange();
                        refetchDataFetch({
                          page: "1",
                          limit: itemsPerRow.name.toString(),
                          start_date: start,
                          end_date: end,
                          status: e.value?.toUpperCase(),
                          isCustomSearch: isCustomSearch,
                          searchFilter: searchFilter,
                          searchParams: searchText,
                          school_id: selectSchool === "" ? null : schoolId,
                          payment_modes: getPaymentMode(
                            filters.paymentMode,
                            type,
                          ),
                          isQrCode: getPaymentMode(
                            filters.paymentMode,
                            type,
                          )?.includes("qr"),
                          gateway: getPaymentMode(filters.gateway, type),
                          vendor_id: filters.vendor_id,
                        });
                      }}
                      placeholder={
                        <div className="text-[#1E1B59] text-xs">Status</div>
                      }
                      value={null}
                      styles={{
                        control: (provided: any) => ({
                          ...provided,
                          backgroundColor: "#F6F8FA",
                          border: "1px solid #1B163B",
                          borderRadius: "6px",

                          minHeight: "15px",
                          margin: "0px",
                          color: "#6687FF",
                        }),
                        valueContainer: (provided: any) => ({
                          ...provided,
                          padding: "0px",
                          paddingLeft: "0.5rem",
                        }),
                        input: (provided: any) => ({
                          ...provided,
                          backgroundColor: "transparent",
                          color: "#000",
                          "::placeholder": {
                            backgroundColor: "#YourDesiredColor",
                            opacity: 1,
                          },
                          placeholder: (provided: any) => ({
                            ...provided,
                            color: "red", // Set the color of the placeholder text
                          }),
                        }),
                      }}
                    />
                  </div>
                  <div className="w-full">
                    <MixFilter
                      gateway={Object.keys(filters.gateway).filter(
                        (key) => filters.gateway[key],
                      )}
                      setSelectSchool={setSelectSchool}
                      setSchoolId={setSchoolId}
                      paymentModes={Object.keys(filters.paymentMode).filter(
                        (key) => filters.paymentMode[key],
                      )}
                      setType={setType}
                      onCancel={() => {
                        setCurrentPage(1);
                        setFilters({
                          paymentMode: {
                            credit_card: false,
                            credit_card_emi: false,
                            upi: false,
                            wallet: false,
                            pay_later: false,
                            cardless_emi: false,
                            net_banking: false,
                            debit_card_emi: false,
                            debit_card: false,
                            na: false,
                          },
                          gateway: Object.keys(gatewayName).reduce(
                            (acc: any, key) => {
                              acc[key] = false;
                              return acc;
                            },
                            {},
                          ),
                          vendor_id: null,
                        });
                        const { start, end } = getActiveDateRange();
                        refetchDataFetch({
                          page: "1",
                          isCustomSearch: isCustomSearch,
                          searchFilter: searchFilter,
                          searchParams: searchText,
                          start_date: start,
                          end_date: end,
                          status: status?.toUpperCase(),
                          limit: itemsPerRow.name.toString(),
                          school_id: selectSchool === "" ? null : schoolId,
                        });
                      }}
                      onApply={() => {
                        setCurrentPage(1);
                        const { start, end } = getActiveDateRange();
                        refetchDataFetch({
                          page: "1",
                          isCustomSearch: isCustomSearch,
                          searchFilter: searchFilter,
                          searchParams: searchText,
                          start_date: start,
                          end_date: end,
                          status: status?.toUpperCase(),
                          limit: itemsPerRow.name.toString(),
                          school_id: selectSchool === "" ? null : schoolId,
                          payment_modes: getPaymentMode(
                            filters.paymentMode,
                            type,
                          )?.includes("qr")
                            ? null
                            : getPaymentMode(filters.paymentMode, type),
                          isQrCode: getPaymentMode(
                            filters.paymentMode,
                            type,
                          )?.includes("qr"),
                          gateway: getPaymentMode(filters.gateway, type),
                          vendor_id: filters.vendor_id,
                        });
                      }}
                      filters={filters}
                      setFilters={setFilters}
                    />
                  </div>
                </div>
              </div>
              <div>
                <RowsPerPageSelect
                  setItemsPerRow={(e: any) => {
                    setCurrentPage(1);
                    setItemsPerRow(e);
                    const { start, end } = getActiveDateRange();
                    refetchDataFetch({
                      page: "1",
                      isCustomSearch: isCustomSearch,
                      searchFilter: searchFilter,
                      searchParams: searchText,
                      start_date: start,
                      end_date: end,
                      status: status?.toUpperCase(),
                      limit: e.name.toString(),
                      school_id: selectSchool === "" ? null : schoolId,
                      payment_modes: getPaymentMode(filters.paymentMode, type),
                      isQrCode: getPaymentMode(
                        filters.paymentMode,
                        type,
                      )?.includes("qr"),
                      gateway: getPaymentMode(filters.gateway, type),
                      vendor_id: filters.vendor_id,
                    });
                  }}
                  itemsPerRow={itemsPerRow}
                  className=" justify-start"
                />
              </div>
              <div className="flex items-center">
                {type !== "" && (
                  <div className=" text-sm m-2  max-w-fit ">
                    <button
                      onClick={async () => {
                        setType("");
                        setCurrentPage(1);
                        const { start, end } = getActiveDateRange();
                        refetchDataFetch({
                          page: "1",
                          limit: itemsPerRow.name.toString(),
                          isCustomSearch: isCustomSearch,
                          searchFilter: searchFilter,
                          searchParams: searchText,
                          start_date: start,
                          end_date: end,
                          status: status?.toUpperCase(),
                          school_id: schoolId === "" ? null : schoolId,
                        });

                        setFilters({
                          paymentMode: {
                            credit_card: false,
                            credit_card_emi: false,
                            upi: false,
                            wallet: false,
                            pay_later: false,
                            cardless_emi: false,
                            net_banking: false,
                            debit_card_emi: false,
                            debit_card: false,
                            na: false,
                          },
                          gateway: Object.keys(gatewayName).reduce(
                            (acc: any, key) => {
                              acc[key] = false;
                              return acc;
                            },
                            {},
                          ),

                          vendor_id: null,
                        });
                      }}
                      className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                    >
                      {type} <HiMiniXMark className=" text-lg ml-1" />
                    </button>
                  </div>
                )}
                {dateRange !== "" && dateRange !== "Today" && (
                  <div className=" text-sm m-2  max-w-fit ">
                    <button
                      onClick={async () => {
                        setSelectedRange({
                          ...todayRange,
                          key: "selection",
                        });
                        setIsDateRangeIsSelected(false);
                        setDateRange("Today");
                        setCurrentPage(1);
                        refetchDataFetch({
                          page: "1",
                          limit: itemsPerRow.name.toString(),
                          isCustomSearch: isCustomSearch,
                          searchFilter: searchFilter,
                          searchParams: searchText,
                          start_date: formatDate(todayRange.startDate),
                          end_date: formatDate(todayRange.endDate),
                          status: status?.toUpperCase(),
                          school_id: schoolId === "" ? null : schoolId,
                          payment_modes: getPaymentMode(
                            filters.paymentMode,
                            type,
                          ),
                          isQrCode: getPaymentMode(
                            filters.paymentMode,
                            type,
                          )?.includes("qr"),
                        });

                        setIsDateRangeIsSelected(false);
                      }}
                      className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                    >
                      {dateRange} <HiMiniXMark className=" text-lg ml-1" />
                    </button>
                  </div>
                )}
                {selectSchool !== "" && (
                  <div className=" text-sm m-2  max-w-fit ">
                    <button
                      onClick={() => {
                        setCurrentPage(1);
                        const { start, end } = getActiveDateRange();
                        refetchDataFetch({
                          page: "1",
                          limit: itemsPerRow.name.toString(),
                          isCustomSearch: isCustomSearch,
                          searchFilter: searchFilter,
                          searchParams: searchText,
                          start_date: start,
                          end_date: end,
                          status: status?.toUpperCase(),

                          payment_modes: getPaymentMode(
                            filters.paymentMode,
                            type,
                          ),
                          isQrCode: getPaymentMode(
                            filters.paymentMode,
                            type,
                          )?.includes("qr"),
                        });
                        setSelectSchool("");
                        setSchoolId(null);
                      }}
                      className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                    >
                      {selectSchool} <HiMiniXMark className=" text-lg ml-1" />
                    </button>
                  </div>
                )}
                {status && (
                  <div className=" text-sm m-2  max-w-fit ">
                    <button
                      onClick={async () => {
                        setCurrentPage(1);
                        const { start, end } = getActiveDateRange();
                        refetchDataFetch({
                          page: "1",
                          limit: itemsPerRow.name.toString(),
                          isCustomSearch: isCustomSearch,
                          searchFilter: searchFilter,
                          searchParams: searchText,
                          start_date: start,
                          end_date: end,
                          school_id: schoolId === "" ? null : schoolId,
                          payment_modes: getPaymentMode(
                            filters.paymentMode,
                            type,
                          ),
                          isQrCode: getPaymentMode(
                            filters.paymentMode,
                            type,
                          )?.includes("qr"),
                          gateway: getPaymentMode(filters?.gateway, type),
                          vendor_id: filters.vendor_id,
                        });
                        setStatus(null);
                      }}
                      className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                    >
                      {status} <HiMiniXMark className=" text-lg ml-1" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          }
          data={[
            [
              "Sr.No",
              "Date & Time",
              "Order ID",
              "Order Amt",
              "Transaction Amt",
              "Payment Method",
              "Status",
              "Student Name",
              "Student ID",
              "Phone No.",
              "Gateway",
              "Capture Status",
              ...(additionalData?.column ? additionalData?.column : []),
            ],
            ...transactionData.map((row: any, index: number) => [
              <div>{row.serialNumber}</div>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div className="truncate" key={row.orderID}>
                  {new Date(row?.transactionTime).toLocaleString("hi")}
                </div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div className=" truncate" key={row.orderID}>
                  {row.custom_order_id ? row.custom_order_id : row.orderID}
                </div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div
                  key={row.orderID}
                >{`${row?.currency === "USD" ? "$" : "₹"}${row.orderAmount}`}</div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div
                  key={row.orderID}
                >{`${row?.currency === "USD" ? "$" : "₹"}${row.transactionAmount}`}</div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div key={row.orderID}>{row.paymentMode}</div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div
                  className={`capitalize ${
                    row.transactionStatus === "success"
                      ? "text-[#04B521]"
                      : row.transactionStatus === "failure" ||
                          row.transactionStatus === "failed"
                        ? "text-[#E54F2F]"
                        : row.transactionStatus === "pending"
                          ? "text-yellow-400"
                          : ""
                  }`}
                  key={row.orderID}
                >
                  {row.transactionStatus?.replaceAll("_", " ")}
                </div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div key={row.orderID}>
                  {row.student_name ? row.student_name : "NA"}
                </div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div key={row.orderID}>
                  {row.student_id ? row.student_id : "NA"}
                </div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div key={row.orderID}>
                  {row.student_phone ? row.student_phone : "NA"}
                </div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div className="truncate" key={row.orderID}>
                  {row?.gateway}
                </div>
              </Link>,
              <Link
                to={getReceiptLink(row?.orderID, row?.school_id)}
                state={{ from: returnPath }}
              >
                <div className="truncate " key={row.orderID}>
                  {row?.capture_status || "NA"}
                </div>
              </Link>,

              ...Object?.values(additionalData?.values[index] || {}).map(
                (d: any) => {
                  const linkRegex = /^https?:\/\/.+$/i;
                  const stringValue = String(d ?? "");
                  const isLink = linkRegex.test(stringValue);
                  return (
                    <Link
                      target={isLink ? "_blank" : "_self"}
                      to={
                        isLink
                          ? stringValue
                          : getReceiptLink(row?.orderID, row?.school_id)
                      }
                      state={{ from: returnPath }}
                      className="truncate max-w-40 block"
                      title={stringValue}
                    >
                      {isLink ? (
                        <HiOutlineExternalLink className="size-5" />
                      ) : (
                        stringValue
                      )}
                    </Link>
                  );
                },
              ),
            ]),
          ]}
          footer={
            <div className="flex justify-center items-center">
              <Pagination
                currentPage={currentPage}
                totalPages={Math.ceil(totalPages)}
                onPageChange={handlePageChange}
              />
            </div>
          }
        />
      ) : null}
    </div>
  );
}
export default Transaction;
